import React from 'react';
import './Herosection.css';
import '../App.css';

function Herosection() {
  return (
    <section className='hero'>
      <div className='hero-container'>
        <div className='hero-content'>
          <h1>
            Ve cómo podemos ayudar a tu empresa en{' '}
            <a
              className='hero-link'
              href='https://appsource.microsoft.com/es-es/marketplace/partner-dir/a5b97b62-cb6d-4502-a735-bf5ffbab2b29/overview'
              target='_blank'
              rel='noreferrer'
            >
              Microsoft.com
            </a>
          </h1>
        </div>
      </div>
      <div className='hero-subheadline'>
        <p>Proveedor de #CyberSeguridad en la nube</p>
      </div>
    </section>
  );
}

export default Herosection;
